import AppAccess from '../components/AppAccess';
import Header from '../components/Header';
import Hero from '../components/Hero';
import MobileLeadButton from '../components/MobileLeadButton';
import Pricing from '../components/Pricing';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Seo from '@/components/Seo';
import { organizationJsonLd } from '@/lib/structured-data';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function Home() {
  return (
    <div className="App pb-24 sm:pb-0">
      <Seo path="/" jsonLd={organizationJsonLd} />
      <Header />
      <main id="main-content">
        <Hero />
        <section className="border-y border-hairline bg-surface-2 py-10 sm:py-12">
          <div className="container mx-auto flex flex-col items-start justify-between gap-6 px-4 sm:flex-row sm:items-center">
            <div className="max-w-xl">
              <p className="mb-2 font-inter text-xs font-semibold uppercase tracking-widest text-brand-600">
                Adım adım kullanım rehberi
              </p>
              <h2 className="type-h3">Önce nasıl çalıştığını görün.</h2>
              <p className="mt-3 font-inter leading-relaxed text-ink-muted">
                Hesap kurulumundan ilk siparişe kadar tüm adımlar, gerçek ekran görüntüleriyle. Bilgi bırakmadan
                inceleyebilirsiniz.
              </p>
            </div>
            <Link to="/nasil-kullanilir" className="modern-btn-outline shrink-0">
              Rehberi inceleyin <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
            </Link>
          </div>
        </section>
        <section className="section-y bg-surface">
          <div className="container mx-auto px-4">
            <p className="mb-3 text-xs font-semibold uppercase tracking-widest text-brand-700">Neden Tilki?</p>
            <h2 className="type-h2 mb-4">Ürünü görün, maliyeti bilin, destekle başlayın</h2>
            <p className="max-w-2xl text-ink-muted leading-relaxed">
              Karar vermeden önce gerçek ekranları inceleyin. Paket ücretini, kurulum kapsamını ve ihtiyaç duyduğunuz
              entegrasyonları birlikte netleştirelim.
            </p>
            <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {[
                [
                  '01',
                  'Toplam ücret baştan belli',
                  'Ana paket ve yemek platformu entegrasyonlarının ücretini ayrı ayrı görün. Seçiminize göre dönem toplamı hemen hesaplanır; KDV ayrıca belirtilir.',
                ],
                [
                  '02',
                  'Kurulum ve eğitim pakete dahil',
                  'Kurulum için ek ücret talep etmiyoruz. Ana paketlerde eğitim ve danışmanlık desteği sunuyoruz.',
                ],
                [
                  '03',
                  'POS sürecinde destek',
                  'Hugin veya Ödeal POS kurulum sürecinde destek oluyoruz. Cihaz, varsa ücretler ve sözleşme sağlayıcıyla yürütülür.',
                ],
                [
                  '04',
                  'Bulut tabanlı çalışma',
                  'Tilki Otomasyon bulutta çalışır. İnternet bağlantısıyla bilgisayar, tablet veya telefonunuzdan işletmenizin masa, sipariş ve rapor ekranlarına erişebilirsiniz.',
                ],
              ].map(([number, title, detail]) => (
                <div key={number} className="rounded-2xl border border-hairline bg-surface-2 p-6">
                  <span className="text-sm font-semibold text-brand-700">{number}</span>
                  <h3 className="mt-3 font-poppins text-lg font-semibold">{title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink-muted">{detail}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="border-y border-hairline bg-surface-2 py-10 sm:py-12" aria-labelledby="loyalty-title">
          <div className="container mx-auto flex flex-col items-start justify-between gap-6 px-4 lg:flex-row lg:items-center">
            <div className="max-w-2xl">
              <p className="mb-3 text-xs font-semibold uppercase tracking-widest text-brand-700">
                Sadakat ve kampanyalar
              </p>
              <h2 id="loyalty-title" className="type-h3">
                Müşterilerinize yeniden gelmek için bir neden sunun
              </h2>
              <p className="mt-3 leading-relaxed text-ink-muted">
                Kampanyalarınızla müşterilerinize harcamalarından puan kazandırın, biriken puanlarını kullanma imkânı
                sunun. Müşterileriniz puanlarını ve ödüllerini Tilki Sadakat üzerinden takip edebilir.
              </p>
              <p className="mt-3 text-sm font-semibold text-brand-700">
                Sadakat ve kampanya yönetimi ana pakete dahil.
              </p>
            </div>
            <div className="flex shrink-0 flex-col items-start gap-3">
              <Link to="/nasil-kullanilir#sadakat" className="modern-btn-outline shrink-0">
                Sadakat akışını inceleyin <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
              </Link>
              <a
                href="https://sadakat.tilkiotomasyon.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex min-h-11 items-center text-sm font-semibold text-brand-700 underline underline-offset-4"
              >
                Sadakat uygulamasını aç
              </a>
            </div>
          </div>
        </section>
        <AppAccess />
        <Pricing />
        <Contact />
      </main>
      <Footer />
      <MobileLeadButton />
    </div>
  );
}
